export enum RequestCodeType {
    Authentication = 0,
    RecoverPassword = 1,
    Confirmation = 2
}